import React, { useEffect, useState } from 'react';
import PreClearanceCategoryForm from '@app/components/apps/PreClearanceCategories/PreClearanceCategoryForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { Col, Row } from 'antd';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const CreatePreClearanceCategoryPage: React.FC = () => {
  const [currentBreadcrumbName, setCurrentBreadcrumbName] = useState<string>('Add Pre-Clearance Category');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/pre-clearance-categories',
      breadcrumbName: 'Pre-Clearance Categories',
    },
    {
      path: '/add-pre-clearance-category',
      breadcrumbName: currentBreadcrumbName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumbName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PreClearanceCategoryForm
            type="create"
            setCurrentBreadcrumName={setCurrentBreadcrumbName}
            pageTitle={'Create Pre-Clearance Category'}
            editable={true}
            id={null}
          />
        </Col>
      </Row>
    </>
  );
};

export default CreatePreClearanceCategoryPage;
